import { apiRequest } from './api';

export function getWorkspaceMetadata(workspaceId) {
  return apiRequest(`/workspaces/${encodeURIComponent(workspaceId)}/metadata`);
}

export function updateWorkspaceMetadata(workspaceId, metadata) {
  return apiRequest(`/workspaces/${encodeURIComponent(workspaceId)}/metadata`, {
    method: 'PATCH',
    body: JSON.stringify({ metadata }),
  });
}
